import React from 'react';

const AIGuruIcon = () => (
    <svg className="w-24 h-24 text-jskool-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.636-6.364l.707.707M19.414 4.586l.707-.707M12 21v-1m6.364-1.636l-.707-.707M6.586 19.414l-.707.707M18 12a6 6 0 11-12 0 6 6 0 0112 0z"></path>
    </svg>
);

const JskoolGptPage: React.FC = () => {
  return (
    <section 
        className="flex-grow flex items-center bg-jskool-cream" 
        style={{
            backgroundImage: `radial-gradient(circle at top left, #0f9d581a, transparent 40%),
                              radial-gradient(circle at bottom right, #db44371a, transparent 40%)`
        }}
    >
      <div className="container mx-auto px-6 py-20 text-center flex flex-col items-center">
        <AIGuruIcon />
        <h1 className="text-4xl md:text-6xl font-heading font-black mt-6 text-jskool-dark">JSkool AI Guru</h1>
        <p className="font-heading text-2xl md:text-3xl font-bold mt-2 bg-clip-text text-transparent bg-gradient-to-r from-jskool-green to-jskool-red">Coming Soon!</p>
        
        <div className="max-w-3xl mx-auto mt-8 text-lg text-jskool-dark/80 space-y-4">
            <p>Get ready to have your questions about Jainism answered instantly! Our AI Guru, powered by cutting-edge technology, is being trained on Jain scriptures and philosophy.</p>
            <p>Whether you're curious about a specific concept, need clarification on a ritual, or want to explore the depths of Jain wisdom, the JSkool AI Guru will be your personal guide. It’s an interactive way to deepen your understanding anytime, anywhere.</p>
        </div>

        <div className="mt-12">
            <div className="bg-white rounded-xl shadow-lg p-6 inline-block">
                <p className="font-heading font-bold text-xl text-jskool-dark">The future of Jain learning is almost here!</p>
                <p className="text-jskool-dark/70 mt-1">Prepare to chat with wisdom itself.</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default JskoolGptPage;
